import { useEffect, useState } from "react";
import { Form, Input, Checkbox, Space, Button, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { serverFetch } from "@server";

const TaskUser = ({ itemDefault, onClose, companyId }) => {
  const [item, setItem] = useState({ ...itemDefault });
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    setItem({ ...itemDefault });
    form.setFieldsValue(itemDefault);
  }, [itemDefault]);

  const onValuesChange = value => setItem(prev => ({ ...prev, ...value }));

  const onSave = () => {
    setLoading(true);
    const body = { ...item, companyId: companyId ?? item.companyId };
    serverFetch("plan/dep", { method: item.id ? "PUT" : "POST", bodyData: body })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const onCancel = () => onClose(false);

  return <div>
    <div className="misoft-modal-overlay" onClick={e => e.target === e.currentTarget && onClose(false)}>
      <div className="misoft-modal-content" style={{ width: 500 }}>
        <div className="misoft-modal-title">
          <span>{item.id ? "Редактировать исполнителя" : "Добавить исполнителя"}</span>
          <CloseOutlined
            className="misoft-section-title-close"
            onClick={() => onClose()} style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}
          />
        </div>
        <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading} style={{ maxWidth: 500 }}>
          <Form.Item label="Активен" name="active" valuePropName="checked">
            <Checkbox>Активен</Checkbox>
          </Form.Item>
          <Form.Item label="Телефон/почта" name="userName" rules={[{ required: true, message: "Введите телефон или почту!" }]}>
            <Input placeholder="Телефон или email" />
          </Form.Item>
          <Form.Item label="Наименование" name="name" rules={[{ required: true, message: "Введите наименование!" }]}>
            <Input placeholder="Наименование" />
          </Form.Item>
          <Form.Item label=" ">
            <Space>
              <Button className="misoft-btn" type="primary" onClick={onSave} loading={loading}>Сохранить</Button>
              <Button className="misoft-btn" onClick={onCancel}>Отмена</Button>
            </Space>
          </Form.Item>
        </Form>
      </div>
    </div>
  </div>;
};

export default TaskUser;
